<template>
    <div>
        <!-- Formulário de Solicitacao para uso em update e create -->
        <v-card>
            <v-card-text>
                <h1>Solicitação de acesso Visitante</h1>
                <v-divider class="my-4"></v-divider>
                <v-row>
                    <v-col cols="12" sm="3" md="2" lg="2">
                        <CapturaFoto :btn-block="true"
                            @image-changed="onSelectedImage"
                            :showOutPreview="false"/>
                        <div v-if="formSolicitacao.foto" class="my-1">
                            <v-img
                                :src="'data:image/jpeg;base64,'+formSolicitacao.foto"
                                width="150" style="border-radius:10px" />
                            <div class="text-center" v-if="formSolicitacao && formSolicitacao.foto">
                                <v-btn color="error"
                                    @click.stop="formSolicitacao.foto = null">
                                    remover imagem
                                </v-btn>
                            </div>
                        </div>
                        <div v-else class="text-error text-center">
                            <div class="title">Sem Foto</div>
                            <!-- <div><span class="info--text"><b>Foto necessária</b></span></div> -->
                        </div>
                    </v-col>
                    <v-col cols="12" sm="9" md="10" lg="10">
                        <v-row v-if="formSolicitacao && formSolicitacao.id">
                            <v-col cols="12" sm="8" md="6">
                                <span class="pa-1 text-grey overline">{{formSolicitacao.id}}</span>
                                <v-divider class="m-4"></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4" md="3">
                                <v-text-field
                                    :rules="rules"
                                    type="date" hide-details
                                    v-model="formSolicitacao.date_expire"
                                    label="Data Limite de acesso"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="3">
                                <v-text-field
                                    :rules="rules"
                                    type="time" hide-details
                                    v-model="formSolicitacao.time_expire"
                                    label="Horário Limite de acesso"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="8" md="6">
                                <v-text-field
                                    :rules="rules"
                                    hide-details
                                    v-model="formSolicitacao.name"
                                    label="Nome Completo"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="5" md="3">
                                <v-text-field
                                    :rules="rules"
                                    v-mask="'###########'"
                                    hide-details
                                    v-model="formSolicitacao.cpf"
                                    label="CPF"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import CapturaFoto from '@/components/layouts/partials/CapturaFoto.vue'
import {mapGetters } from 'vuex';
export default {
    components:{
        CapturaFoto
    },
    props:{
        propObject:{
            default:{
                foto:null,
                date_expire:null,
                time_expire:null,
                name:null,
                cpf:null,
            }
        },
    },
    data:()=>({
        formSolicitacao:{
            default:{
                foto:null,
                date_expire:null,
                time_expire:null,
                name:null,
                cpf:null,
            }
        },
        rules:[ v => !!v || 'Campo Obrigatório'],
    }),
    mounted(){
        this.initForm()
    },
    methods:{
        onSelectedImage(value){
            if (value){
                this.formSolicitacao.foto = value
            }
        },
        initDateExpire(days){
            // adicionar default no campo data
            let data = new Date();
            let add_days = days;
            data.setDate(data.getDate() + add_days);
            let year = data.getFullYear()
            let month = ("0" + (data.getMonth() + 1)).slice(-2)
            let day = data.getDate()
            let formatted = `${year}-${month}-${("0"+day).slice(-2)}`
            return formatted
        },
        initForm(){
            if(!this.formSolicitacao.date_expire){
                this.formSolicitacao.date_expire = this.initDateExpire(1)
                this.formSolicitacao.time_expire = '23:59'
            }
        },
    },
    computed:{
        ...mapGetters(['StateDark']),
    },
    watch:{
        formSolicitacao:{
            handler(value){
                this.$emit('on-changed',value)
            }, deep: true
        },
        propObject:{
            handler(value){
                const prop = value
                this.formSolicitacao = prop
            }, deep: true
        }
    }
}
</script>